export const START_GET_LOGIN_USER = "START_GET_LOGIN_USER";
export const SUCCESS_GET_LOGIN_USER = "SUCCESS_GET_LOGIN_USER";
export const ERROR_GET_LOGIN_USER = "ERROR_GET_LOGIN_USER";

export const START_GET_PHARMACY_CONFIG = "START_GET_PHARMACY_CONFIG";
export const SUCCESS_GET_PHARMACY_CONFIG = "SUCCESS_GET_PHARMACY_CONFIG";
export const ERROR_GET_PHARMACY_CONFIG = "ERROR_GET_PHARMACY_CONFIG";

export const START_GET_REFRESHTOKEN = "START_GET_REFRESHTOKEN";
export const SUCCESS_GET_REFRESHTOKEN = "SUCCESS_GET_REFRESHTOKEN";
export const ERROR_GET_REFRESHTOKEN = "ERROR_GET_REFRESHTOKEN";

export const START_UPDATE_FIRST_LOGIN_TOUR = "START_UPDATE_FIRST_LOGIN_TOUR";
export const SUCCESS_UPDATE_FIRST_LOGIN_TOUR = "SUCCESS_UPDATE_FIRST_LOGIN_TOUR";
export const ERROR_UPDATE_FIRST_LOGIN_TOUR = "ERROR_UPDATE_FIRST_LOGIN_TOUR";
